__turbopack_context__.v({
  "articleItem": "LatestNewsLayout-module-scss-module__A4ZdYa__articleItem",
  "boxItem": "LatestNewsLayout-module-scss-module__A4ZdYa__boxItem",
  "container": "LatestNewsLayout-module-scss-module__A4ZdYa__container",
  "injectableItem": "LatestNewsLayout-module-scss-module__A4ZdYa__injectableItem",
});
